module.exports = __webpack_public_path__ + "img/richard.65cc6291.jpg";